var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 13.6L2.33335 8.93332C2.21132 8.8098 2.06599 8.71173 1.90577 8.6448C1.74556 8.57787 1.57365 8.5434 1.40002 8.5434C1.22639 8.5434 1.05448 8.57787 0.894266 8.6448C0.734051 8.71173 0.588717 8.8098 0.466686 8.93332C0.343167 9.05535 0.245098 9.20069 0.178165 9.3609C0.111232 9.52112 0.076767 9.69302 0.076767 9.86666C0.076767 10.0403 0.111232 10.2122 0.178165 10.3724C0.245098 10.5326 0.343167 10.678 0.466686 10.8L6.05335 16.3867C6.57335 16.9067 7.41335 16.9067 7.93335 16.3867L22.0667 2.26666C22.1902 2.14463 22.2883 1.99929 22.3552 1.83908C22.4221 1.67886 22.4566 1.50696 22.4566 1.33332C22.4566 1.15969 22.4221 0.987783 22.3552 0.827569C22.2883 0.667355 22.1902 0.522021 22.0667 0.39999C21.9447 0.27647 21.7993 0.178401 21.6391 0.111469C21.4789 0.0445359 21.307 0.0100708 21.1334 0.0100708C20.9597 0.0100708 20.7878 0.0445359 20.6276 0.111469C20.4674 0.178401 20.3221 0.27647 20.2 0.39999L7.00002 13.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/checkBox.39ab004f.svg";
export { ForwardRef as ReactComponent };